'use client'

import { motion } from 'framer-motion'
import { Container } from '@/components/container'
import { Button } from '@/components/button'
import { Heading, Lead, Subheading } from '@/components/text'
import { LogoTimelineTech } from './logo-timeline-tech'
import { LogoTimelineFrontend } from './logo-timeline-frontend'
import { BentoCard } from './bento-card'



export function TechStack() {
  return (
    <div className="py-24 bg-white">
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Subheading className="text-blue-600">
            Tech Stack
          </Subheading>
          <Heading as="h2" className="mt-2">
            I&apos;m proficient in the following technologies
          </Heading>
        </motion.div>

        <BentoCard
          eyebrow="Tech Stack"
          graphic={<LogoTimelineFrontend/>}
          className="lg:col-span-1 transition-all duration-300 hover:scale-105 hover:z-10 relative mt-10"
        />

      </Container>
    </div>
  )
} 